import { render, staticRenderFns } from "./SelectPayment.vue?vue&type=template&id=48ae065c"
import script from "./SelectPayment.vue?vue&type=script&lang=ts"
export * from "./SelectPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports